import Link from "next/link";
import Image from "next/image";
import { useState } from "react";
import MiniSearch from "minisearch";
import SearchIcon from "../../../../public/images/icons/search-icon.png";
import styles from "../../../styles/races/local/LocalRace.module.scss";

const LocalRace = ({ path, url, cityList, provincesList }) => {
  const [query, setQuery] = useState("");
  const miniSearch = new MiniSearch({
    fields: ["name"],
    storeFields: ["name", "display_name", "slug"],
  });

  const loader = ({ src, width, quality }) => {
    const imageUrl = process.env.SITE_URL;
    return `${imageUrl}${src}?w=${width}&q=${quality || 75}`;
  };

  const searchLocal = () => {
    const result = miniSearch.search(query, { prefix: true, fuzzy: 0.2 });
    if (result.length) {
      return result;
    } else {
      return [];
    }
  };

  const listLocalByPath = () => {
    miniSearch.removeAll();

    switch (path) {
      case "metro-manila":
        if (query.length >= 2) {
          miniSearch.addAll(cityList);
          return searchLocal();
        }
        return cityList;
      case "provinces":
        if (query.length >= 2) {
          miniSearch.addAll(provincesList);
          return searchLocal();
        }
        return provincesList;
      case "independent-cities":
        if (query.length >= 2) {
          miniSearch.addAll(cityList);
          return searchLocal();
        }
        return cityList;
      default:
        break;
    }
  };

  const onChange = (event) => {
    const query = event.target.value;
    setQuery(query);
  };

  return (
    <div className={styles.locRaceContainer}>
      <h2>LOCAL RACES</h2>
      <div className={styles.locRaceWrapper}>
        <div className={styles.navContainer}>
          <Link href="/elections/2022/metro-manila" passHref>
            <a className={path === "metro-manila" ? styles.highlight : ""}>
              METRO MANILA
            </a>
          </Link>
          <Link href="/elections/2022/provinces" passHref>
            <a className={path === "provinces" ? styles.highlight : ""}>
              PROVINCES
            </a>
          </Link>
          <Link href="/elections/2022/independent-cities" passHref>
            <a
              className={path === "independent-cities" ? styles.highlight : ""}
            >
              INDEPENDENT CITIES
            </a>
          </Link>
        </div>
        <div className={styles.searchCity}>
          <div className={styles.search}>
            <label>
              <span className={styles.screenReaderPlaceholder}>
                {path === "provinces"
                  ? "Search for a Province or Select a Province"
                  : path === "metro-manila"
                  ? "Search for a City or Municipality or Select a City or Municipality"
                  : "Search for a City or Select a City"}
              </span>
              <input
                className={styles.searchBox}
                name="cities"
                type="text"
                placeholder={
                  path === "provinces"
                    ? "Select Province"
                    : path === "metro-manila"
                    ? "Select City or Municipality"
                    : "Select City"
                }
                value={query}
                onChange={onChange}
                autoComplete="off"
              />
            </label>
            <div className={styles.searchIcon}>
              <Image
                loader={loader}
                src={SearchIcon}
                alt="search"
                layout="responsive"
                width={17.49}
                height={17.49}
              />
            </div>
          </div>
        </div>
        <div className={styles.cityListContainer}>
          {listLocalByPath()?.length
            ? listLocalByPath().map((res) => (
                <Link
                  key={res.id}
                  href={`/elections/2022/${res.slug}`}
                  passHref
                >
                  <a className={res.slug ? styles.cityName : styles.hidden}>
                    <div className={styles.cityNameInner}>
                      {res.display_name}
                    </div>
                  </a>
                </Link>
              ))
            : "No results found."}
        </div>
      </div>
    </div>
  );
};

export default LocalRace;
